import { makeAuthedRequest } from "utils/makeAuthedRequest";
import { useMutation } from "react-query";

export function useActivityPopUp() {
  const updateUserActivity = useMutation(
    () =>
      makeAuthedRequest("v1/settings/activity", {
        method: "PUT",
      }).then(async (res) => {
        if (res.ok) {
          return res.json();
        } else {
          const body = await res.json();
          throw new Error(body.message);
        }
      }),
    {
      onSuccess: (data) => {
        // console.log("Response:", data);
      },
      onError: (err) => {
        console.error(err);
      },
    }
  );

  return {
    updateUserActivity,
  };
}
